export default {
  modal: {
    // To render above the whole site. Alerts are at index 5
    zIndex: 6,
    position: 'fixed',
    display: 'block',
    visibility: 'hidden',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    height: 0,
    opacity: '0.7'
  },

  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },

  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scale(.85)',
    opacity: 0
  },

  modalOpen: {
    height: '100%',
    opacity: '1',
    visibility: 'visible',
    transition: 'opacity 0.2s cubic-bezier(0.65, 0, 0.35, 1)'
  },

  contentOpen: {
    opacity: '1',
    transform: 'translate(-50%, -50%) scale(1)',
    transitionProperty: 'opacity, transform',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'cubic-bezier(0.65, 0, 0.35, 1)',
    transitionDelay: '0.15s'
  }
}
